export const ROISTAT_VISIT_ID =
  localStorage.getItem("roistat_visit") ||
  document.cookie
    .split("; ")
    .find(row => row.startsWith("roistat_visit="))
    .split("=")[1];

export const OFFER_DEFAULT = "https://www.ufanet.ru/media/uploads/2022/12/12/oferta23.pdf";
export const OFFER_SBER = "https://www.ufanet.ru/media/uploads/2022/12/02/oferta_sberagent.pdf";
export const PRIVATE_DATA_POLICY = "https://www.ufanet.ru/pages/politika-konfidencialnosti-ufanet/";
export const AGREEMENT = "https://my.ufanet.ru/media/files/lk_approve_processing.pdf";
export const ADS = "https://my.ufanet.ru/media/files/lk_approve_get_info.pdf";
export const CNS_INFO_STYLES =
  "color: white; background-color: dodgerblue; border-radius: 2px; padding: 2px 4px";
